require('angular-ui-router');
require('angular-aria');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/planner_app.ts